import { Injectable } from '@angular/core';
import { fromWorker } from 'observable-webworker';
import { Observable, ReplaySubject, Subscription } from 'rxjs';

@Injectable()
export abstract class BaseWorkerLoaderService<TParams, TResponse> {
  private _signalRSubscription: Subscription;
  private _workerInput$ = new ReplaySubject<TParams>(100);
  private _response$ = new ReplaySubject<TResponse>();
  readonly response$ = this._response$.asObservable();

  /**
   * Notify the worker so it will initialize signalR.
   */
  protected abstract emitInitializeWorker(): void;
  protected abstract getWorker(): Worker;

  start(): void {
    const response$ = this.loadWorker();

    this.emitInitializeWorker();

    this._signalRSubscription = response$.subscribe((response: TResponse) => {
      this._response$.next(response);
    });
  }

  sendParams(params: TParams): void {
    this._workerInput$.next(params);
  }

  stop(): void {
    this._signalRSubscription.unsubscribe();
  }

  private loadWorker(): Observable<TResponse> {
    const response$ = fromWorker<TParams, TResponse>(
      () => this.getWorker(),
      this._workerInput$.asObservable()
    );
    return response$;
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
